import SelectedGamePopup from 'live/components/SelectedGamePopup';
import { liveDeleteGame, liveSetSelectedGame } from 'live/redux/actions';
import { selectedGame } from 'live/redux/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { user } from 'shared/redux/selectors';

const mapStateToProps = state => ({
  error: selectedGame.getSelectedGameError(state),
  game: selectedGame.getSelectedGame(state),
  isAdmin: user.getUserIsAdmin(state),
  loading: selectedGame.getSelectedGameLoading(state),
  userId: user.getUserId(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onDelete: liveDeleteGame,
      onClose: () => liveSetSelectedGame(),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SelectedGamePopup);
